import React, { Component } from "react";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import {
  FaRegFilePdf,
  FaRegImage,
  FaRegFileExcel,
  FaRegFileWord,
  FaEye,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import { Dropdown, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

class TableExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataColumn: [],
    };
  }

  componentDidMount() {
    console.log("datatattaatdatatattaatdatatattaat", this.props);
    let dataColumn = JSON.parse(JSON.stringify(this.props.dataColumn));
    console.log("dataColumn", dataColumn);
    if (Array.isArray(dataColumn) && dataColumn.length > 0) {
      console.log("this.props.fullData", this.props.fullData);
      if (this.props.fullData) {
        this.setState({
          dataColumn: dataColumn,
        });
      } else {
        dataColumn.pop();
        this.setState({
          dataColumn: dataColumn,
        });
      }
    }
  }

  exportHtmlTableToWordFile = (e) => {
    e.preventDefault();
    // this.props.exportHtmlTableToWordFile();
    var filename = "";
    var preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><style>table {font-family: arial, sans-serif;border-collapse: collapse;width: 100%;} td, th {  border: 1px solid #dddddd; text-align: left; padding: 8px; } tr:nth-child(even) {background-color: #dddddd; } </style><meta charset='utf-8'><title>Export HTML To Doc</title></head><body><table>";
    var postHtml = "</table></body></html>";
    var html =
      preHtml + document.getElementById(this.props.tableName).innerHTML + postHtml;
    var blob = new Blob(["\ufeff", html], {
      type: "application/msword",
    });
    var url = "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);
    filename = filename ? filename + ".doc" : "document.doc";
    var downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  };

  render() {
    const { renderData, searchText } = this.props;
    const { dataColumn } = this.state;

    return (
      <React.Fragment>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top1">Export as an Excel</Tooltip>}
        >
          <div className="btn-icon">
            <span onClick={() => exportToExcel(this.props.tableName)}>
              <FaRegFileExcel />
            </span>
          </div>
        </OverlayTrigger>

        {!this.props?.hideExportWord && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top1">Export as a Word</Tooltip>}
          >
            <Button
              className="btn-icon"
              onClick={(e) => this.exportHtmlTableToWordFile(e)}
            >
              <FaRegFileWord />
            </Button>
          </OverlayTrigger>
        )}

        <div className="d-none">
          {dataColumn && dataColumn.length > 0 ? (
            <ToolkitProvider
              striped
              keyField="id"
              data={renderData}
              columns={dataColumn}
              search
            >
              {(props) => (
                <>
                  <div className="d-flex align-items-center justify-content-between pb-3">
                    <MySearch {...props.searchProps} text={searchText} />
                  </div>

                  <BootstrapTable
                    id={this.props.tableName}
                    {...props.baseProps}
                    bootstrap4
                    // pagination={paginationFactory(paginationOptions)}
                    noDataIndication={"Table is empty"}
                  />
                </>
              )}
            </ToolkitProvider>
          ) : (
            ""
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default TableExport;

const MySearch = (props) => {
  props.onSearch(props.text);
  return <div></div>;
};

export const exportToExcel = async (tableIdName, fileName) => {
  const table = document.getElementById(tableIdName);
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet");

  // Add headers
  const headers = [];
  table.querySelectorAll("thead tr th").forEach((th) => {
    headers.push(th.innerText);
  });
  const headerRow = worksheet.addRow(headers);

  // Style the header
  headerRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
  });

  // Set column widths
  headers.forEach((header, index) => {
    worksheet.getColumn(index + 1).width = header.length < 15 ? 15 : header.length + 5;
  });

  // Add data
  const rows = [];
  table.querySelectorAll("tbody tr").forEach((tr) => {
    const row = [];
    tr.querySelectorAll("td").forEach((td) => {
      row.push(td.innerText);
    });
    rows.push(row);
  });

  rows.forEach((row) => {
    worksheet.addRow(row);
  });

  // Generate the Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const data = new Blob([buffer], { type: "application/octet-stream" });
  const file_name = fileName || "ReportExcel.xlsx";
  saveAs(data, file_name);
};
